const PV_CONFIG: Record<string, string> = {
  "/": "chat",
  "/videoUnderstanding": "video",
};

export const sendCLK = (
  action: string,
  label?: string,
  value?: number,
  nodeid?: string,
) => {
  try {
    const pathname = window.location.pathname;

    let category = PV_CONFIG[pathname];
    !category && (category = "other");

    // @ts-ignore
    if (window._czc) {
      // @ts-ignore
      window._czc.push(["_trackEvent", category, action, label, value, nodeid]);
    }
  } catch (error) {
    console.log("sendCLK error: ", error);
  }
};

export const sendPV = (pathname: string) => {
  try {
    sendCLK(pathname);
  } catch (error) {
    console.log("sendPV error: ", error);
  }
};
